import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { postToPlan } from '../utils/planFrame';

const DIAGRAM_PATH = /^\/diagrams\/[^/]+\/?$/;

export default function PlanFrameGuard() {
  const location = useLocation();
  const history = useHistory();
  const lastDiagram = useRef(null);
  useEffect(() => {
    const url = `${location.pathname}${location.search}`;
    if (DIAGRAM_PATH.test(location.pathname)) {
      lastDiagram.current = url;
      return;
    }
    postToPlan({ type: 'leave', url });
    if (lastDiagram.current) history.replace(lastDiagram.current);
  }, [location, history]);
  return null;
}
